import React from 'react';
import PropTypes from 'prop-types';
import { List, Subheader, Divider, Paper } from 'material-ui';
import Error from '../common/Error/Error';
import PageItem from './PageItem';
import style from '../../styles/styles';

const PageList = (props) => {
    const { pages, title, user, app, currentLang } = props;

    let content;

    if (pages.length === 0) {
        content =
            <Error
                title="No data"
                subtitle="Add some news"
            />;
    } else {
        content = pages[currentLang]
            .sort((a, b) => {return a.display_order - b.display_order;})
            .map(function (page, index) {
            return <div key={page.id}>
                <PageItem
                    app={app}
                    user={user}
                    page={page}
                />
                {index !== (pages.length - 1) && <Divider inset={true} />}
            </div>;
        });
    }

    return (
        <Paper>
            <List>
                <Subheader style={style.subHeader}>{title}</Subheader>
                {content}
            </List>
        </Paper>
    );
};

PageList.propTypes = {
    pages: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    title: PropTypes.string,
    currentLang: PropTypes.string,
};

export default PageList;



// WEBPACK FOOTER //
// src/components/page/PageList.js